'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddItemsButton = require('./components/AddItemsButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddItemsButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-items-button/index.js
// module id = 915
// module chunks = 0